import axios from "axios";

export const getTermsAndConditions = async (token: string) => {
  const response = await axios.get(
    `${process.env.REACT_APP_API_BASE_URL}/cms/termsAndConditions`
  );
  return response.data;
};

export const updateTermsAndConditions = async (token: string, data: object) => {
  const response = await axios.patch(
    `${process.env.REACT_APP_API_BASE_URL}/cms/terms-and-conditions`,
    data
  );
  return response.data;
};
